import { formatDate, FormStyle, getLocaleMonthNames, TranslationWidth } from "@angular/common";
import { Inject, Injectable, LOCALE_ID } from "@angular/core";

import { DateFormat } from "./date.model";

/**
 * @deprecated -[fabric-deprecated] - Use date-service from svc-platform instead.
 * */
@Injectable({
	providedIn: "root",
})
export class DateService {
	constructor(@Inject(LOCALE_ID) private locale: string) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use PlatformServiceCommand.FormatDate or PlatformServiceCommand.FormatDateInTimezone instead
	 *
	 * Formats a date according to locale rules.
	 *
	 * {@link https://angular.io/api/common/DatePipe Complete date format list}
	 *
	 * @param value Date object or a number (milliseconds since UTC epoch) or an ISO string
	 * @param [dateFormat] Indicates which date/time  to include.
	 * The format can be predefined as shown below (all examples are given for `en-US`) or custom as shown in the table.
	 * - `'short'`: equivalent to `'M/d/yy, h:mm a'` (e.g. `6/15/15, 9:03 AM`)
	 * - `'medium'`: equivalent to `'MMM d, y, h:mm:ss a'` (e.g. `Jun 15, 2015, 9:03:01 AM`)
	 * - `'long'`: equivalent to `'MMMM d, y, h:mm:ss a z'` (e.g. `June 15, 2015 at 9:03:01 AM GMT+1`)
	 * - `'full'`: equivalent to `'EEEE, MMMM d, y, h:mm:ss a zzzz'` (e.g. `Monday, June 15, 2015 at 9:03:01 AM GMT+01:00`)
	 * - `'shortDate'`: equivalent to `'M/d/yy'` (e.g. `6/15/15`)
	 * - `'mediumDate'`: equivalent to `'MMM d, y'` (e.g. `Jun 15, 2015`)
	 * - `'longDate'`: equivalent to `'MMMM d, y'` (e.g. `June 15, 2015`)
	 * - `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` (e.g. `Monday, June 15, 2015`)
	 * - `'shortTime'`: equivalent to `'h:mm a'` (e.g. `9:03 AM`)
	 * - `'mediumTime'`: equivalent to `'h:mm:ss a'` (e.g. `9:03:01 AM`)
	 * - `'longTime'`: equivalent to `'h:mm:ss a z'` (e.g. `9:03:01 AM GMT+1`)
	 * - `'fullTime'`: equivalent to `'h:mm:ss a zzzz'` (e.g. `9:03:01 AM GMT+01:00`)
	 * @param timezone to be used for formatting the time. It understands UTC/GMT and the continental US time zone
	 */
	format(
		value: number | Date | string | null | undefined,
		dateFormat: string | DateFormat = "mediumDate",
		timezone?: string,
		locale = this.locale
	): string | null {
		return value ? formatDate(value, dateFormat, locale, timezone) : null;
	}

	getMonthNames(width: TranslationWidth = TranslationWidth.Wide, locale = this.locale): readonly string[] {
		return getLocaleMonthNames(locale, FormStyle.Standalone, width);
	}
}
